/**
 * ExpandableText, a component used to expand/collapse a big block of text.
 */

import React from 'react';
import EditDescriptionButton from './EditDescriptionButton';
import LastEditedBy from './LastEditedBy.jsx';
import {RegionType} from '../../utils/gaia/RegionType';
import trackAnalytics from '../../utils/gaia/trackAnalytics';

export default class ExpandableText extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showExpandButton: props.showExpandButton,
            text: props.text,
            textIsExpanded: props.expandDescriptionInitially,
        };
    }

    componentWillMount() {
        import('showdown').then(({default: showdown}) => {
            const converter = new showdown.Converter();
            converter.setOption('simpleLineBreaks', true);
            this.setState({showdown: converter});
        });
        import('sanitize-html')
            .then(({default: sanitizeHTML}) => this.setState({sanitizeHTML}));
    }

    renderMarkdown(text) {
        if (!this.state.showdown || !this.state.sanitizeHTML) return text;

        return (<span dangerouslySetInnerHTML={{
            __html: this.state.sanitizeHTML(this.state.showdown.makeHtml(text), {
                // keep these settings in sync with `comments.py`
                tags: [
                    'a', 'blockquote', 'br', 'code', 'em', 'h1', 'h2', 'h3', 'h4', 'h5',
                    'h6', 'hr', 'img', 'li', 'ol', 'p', 'pre', 'strong', 'ul'
                ],
                attributes: {
                    a: ['href', 'title'],
                    img: ['src', 'title', 'alt']
                },
                styles: []
            })
        }} />);
    }

    render() {
        const divs = [];
        let index = 0;
        for (const section of this.state.text) {
            if (section.text && section.text.length > 0) {
                divs.push(<h4 key={`header${index}`} className='hk-info-header'>
                    {section.title}
                </h4>);
                divs.push(<span key={`span${index}`}>{this.renderMarkdown(section.text)}</span>);
                index++;
            }
        }
        return (
            <div>
                <div
                    id="description"
                    style={this.state.textIsExpanded ? {maxHeight: 10000} : {maxHeight: 150}}
                >
                    {divs}
                </div>
                <div style={{
                    maxWidth: this.state.showExpandButton ? 290 : 200,
                    height: 50,
                    position: 'relative'
                }}>
                    {this.props.regionType !== RegionType.TRAIL &&
                        <EditDescriptionButton style={{position: 'absolute',  bottom: 0, left: 0}}
                            afterUpdate={desc => {
                                this.setState({
                                    text: desc,
                                    showExpandButton: (
                                        desc.length > 1 &&
                                        desc[1].text &&
                                        desc[1].text.length > 0 &&
                                        !this.props.expandDescriptionInitially
                                    )
                                });

                            }}
                            anchorTitle={'Edit'}
                            apiEndpoint={'update'}
                            editedText={this.props.description === this.props.originalText ?
                                null :
                                this.props.description
                            }
                            editTitle={'Edit Description'}
                            initialStaticDescription={this.props.initialStaticDescription}
                            regionId={this.props.regionId}
                            regionType={this.props.regionType}
                            originalText={this.props.originalText}
                        />
                    }
                    {this.state.showExpandButton &&
                        <span style={{verticalAlign: 'top'}}>
                            <span style={{verticalAlign: 'baseline'}}>
                                &nbsp;&nbsp;|&nbsp;&nbsp;
                            </span><a
                                href="#"
                                title={this.anchorTitle()}
                                onClick={e => { e.preventDefault(); this.toggleState(); }}
                            >
                                {this.anchorTitle()}
                            </a>
                        </span>
                    }
                    {this.props.regionType !== RegionType.POI &&
                        this.props.regionType !== RegionType.TRAIL &&
                        this.props.lastEditedBy &&
                        <LastEditedBy lastEditedBy={this.props.lastEditedBy} />
                    }
                </div>
            </div>
        );
    }

    toggleState() {
        const toggled = !this.state.textIsExpanded;
        this.setState({textIsExpanded: toggled});
        trackAnalytics('Description Toggle', {
            category: 'Hike',
            textIsExpanded: this.state.textIsExpanded,
        });
    }

    anchorTitle() {
        if (this.state.textIsExpanded) {
            return 'Show Less...';
        } else {
            return 'Show More...';
        }
    }

}
